import React from 'react';
import usePlaidLink from 'Hooks/usePlaidLink';
import PropTypes from 'prop-types';

export default function PlaidButton({
  onSuccess, onFailure, onExit, onClick, plaidTokenLink, onLoad, component, ...rest
}) {
  const { handleClick, disabled } = usePlaidLink({
    onSuccess, onFailure, onExit, onClick, plaidTokenLink, onLoad,
  });
  const Component = component;
  return (
    <Component
      onClick={handleClick}
      disabled={disabled}
      {...rest}
    />
  );
}


PlaidButton.propTypes = {
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  onExit: PropTypes.func,
  onClick: PropTypes.func,
  products: PropTypes.array,
};

PlaidButton.defaultProps = {
  onSuccess: () => {},
  onFailure: () => {},
  onExit: () => {},
  onClick: () => {},
  products: ['transactions'],
};
